module.exports = __webpack_public_path__ + "img/movement_logos_lockup.e14da656.svg";